/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SendAMessageInAConversationRequest,
} from '../models/index';
import {
    SendAMessageInAConversationRequestFromJSON,
    SendAMessageInAConversationRequestToJSON,
} from '../models/index';

export interface SendAMessageInAConversationOperationRequest {
    conversationId: number;
    sendAMessageInAConversationRequest: SendAMessageInAConversationRequest;
}

/**
 * MessagesApi - interface
 * 
 * @export
 * @interface MessagesApiInterface
 */
export interface MessagesApiInterface {
    /**
     * Posts a new message to the given conversation. 404 if the authenticated user is not a participant. The other participant receives a `NewMessageReceived` notification (database + broadcast channels). Updates the conversation\'s `last_message_at` timestamp so the inbox sorts correctly.
     * @summary Send a message in a conversation
     * @param {number} conversationId The ID of the conversation.
     * @param {SendAMessageInAConversationRequest} sendAMessageInAConversationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApiInterface
     */
    sendAMessageInAConversationRaw(requestParameters: SendAMessageInAConversationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Posts a new message to the given conversation. 404 if the authenticated user is not a participant. The other participant receives a `NewMessageReceived` notification (database + broadcast channels). Updates the conversation\'s `last_message_at` timestamp so the inbox sorts correctly.
     * Send a message in a conversation
     */
    sendAMessageInAConversation(requestParameters: SendAMessageInAConversationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class MessagesApi extends runtime.BaseAPI implements MessagesApiInterface {

    /**
     * Posts a new message to the given conversation. 404 if the authenticated user is not a participant. The other participant receives a `NewMessageReceived` notification (database + broadcast channels). Updates the conversation\'s `last_message_at` timestamp so the inbox sorts correctly.
     * Send a message in a conversation
     */
    async sendAMessageInAConversationRaw(requestParameters: SendAMessageInAConversationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling sendAMessageInAConversation().'
            );
        }

        if (requestParameters['sendAMessageInAConversationRequest'] == null) {
            throw new runtime.RequiredError(
                'sendAMessageInAConversationRequest',
                'Required parameter "sendAMessageInAConversationRequest" was null or undefined when calling sendAMessageInAConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/conversations/{conversation_id}/messages`;
        urlPath = urlPath.replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters['conversationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendAMessageInAConversationRequestToJSON(requestParameters['sendAMessageInAConversationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Posts a new message to the given conversation. 404 if the authenticated user is not a participant. The other participant receives a `NewMessageReceived` notification (database + broadcast channels). Updates the conversation\'s `last_message_at` timestamp so the inbox sorts correctly.
     * Send a message in a conversation
     */
    async sendAMessageInAConversation(requestParameters: SendAMessageInAConversationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendAMessageInAConversationRaw(requestParameters, initOverrides);
    }

}
